import Cookies from 'js-cookie';

export const isFeatureFlagSet = (flag) => {
    return Cookies.get(`feature-flag-${flag}`) === 'true';
}

export const setFeatureFlag = (flag) => {
    Cookies.set(`feature-flag-${flag}`, 'true', { expires: 1 });
}

export const removeFeatureFlag = (flag) => {
    Cookies.remove(`feature-flag-${flag}`);
}